<template>
  <div class="layout-wrapper d-flex flex-column">
    <div class="topbar d-flex">
      <div class="brand shadow d-flex align-items-center justify-content-center">
        <Link href="/"><h4 class="text-light">PERTANIAN</h4></Link>
      </div>
      <nav class="flex-fill py-3 navbar navbar-expand navbar-light bg-white shadow">
        <div class="container-fluid">
          <Link class="navbar-brand" href="#">
            <Icon :icon="['fa', 'bars']" />
          </Link>
          <ul class="navbar-nav">
            <li class="nav-item">
              <Link class="nav-link active" aria-current="page" href="#">Pencarian</Link>
            </li>
            <li class="nav-item">
              <Link class="nav-link" href="#">Notifikasi</Link>
            </li>
            <li class="nav-item dropdown">
              <Link class="nav-link dropdown-toggle" @click.prevent="show_account = !show_account">Akun <Icon :icon="['fa', 'chevron-down']" /></Link>
              <ul class="dropdown-menu" :class="{ 'show': show_account }" style="right: 0;">
                <li><Link class="dropdown-item" href="#">Profil</Link></li>
                <li><Link class="dropdown-item" href="#">Pengaturan Akun</Link></li>
                <li><hr class="dropdown-divider" /></li>
                <li><Link class="dropdown-item" @click.prevent="logout">Logout</Link></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="main-content d-flex flex-fill">
      <div class="sidebar p-3">
        <nav class="nav flex-column">
          <li class="nav-link active">
            <Link href="/admin/dashboard">
              <Icon :icon="['fa', 'home']" />
              <span>Dashboard</span>
            </Link>
          </li>
          <!-- <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'bullhorn']" />
              <span class="badge rounded-pill bg-primary float-end">3</span>
              <span>Pengumuman</span>
            </Link>
          </li> -->
<!-- 
          <li class="menu-title">EPROPOSAL</li>
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/kamususulandata">
              <Icon :icon="['fa', 'book-open']" />
              <span>Kamus Usulan</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="/admin/usulan">
              <Icon :icon="['fa', 'magic-wand-sparkles']" />
              <span>Usulan</span>
            </Link>
          </li> -->

          <!-- <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'map-location-dot']" />
              <span>Titik Lokasi</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'file-circle-check']" />
              <span>Verifikasi</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'file-pen']" />
              <span>Review</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'wallet']" />
              <span>Pendanaan</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'chart-pie']" />
              <span>Statistik</span>
            </Link>
          </li> -->
          <!-- <li class="menu-title">PORTAL</li>
          <li class="nav-link">
            <Link href="/admin/portal/posts">
              <Icon :icon="['fa', 'newspaper']" />
              <span>Postingan</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="/admin/portal/pages">
              <Icon :icon="['fa', 'pager']" />
              <span>Pages</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="/admin/portal/slider">
              <Icon :icon="['fa', 'columns']" />
              <span>Slider</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'forward']" />
              <span>Running Text</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'calendar']" />
              <span>Setting Halaman</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'gears']" />
              <span>Setting Menu</span>
            </Link>
          </li> -->
          <li class="menu-title">MANAJEMEN DATA</li>
          <li class="nav-link" v-if="[1,2,3].includes(role_id)">
            <Link href="/admin/poktan">
              <Icon :icon="['fa', 'building']" />
              <span>Kelompok Tani</span>
            </Link>
          </li>
          <!-- <li class="nav-link">
            <Link href="/admin/instansidata">
              <Icon :icon="['fa', 'building']" />
              <span>Instansi</span>
            </Link>
          </li> -->
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/penggunaandata">
              <Icon :icon="['fa', 'bridge']" />
              <span>Penggunaan</span>
            </Link>
          </li>
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/domisilidata">
              <Icon :icon="['fa', 'map-location-dot']" />
              <span>Domisili</span>
            </Link>
          </li>
          <!-- <li class="nav-link">
            <Link href="/admin/skpddata">
              <Icon :icon="['fa', 'sitemap']" />
              <span>SKPD</span>
            </Link>
          </li> -->
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/elementsdata">
              <Icon :icon="['fa', 'th']" />
              <span>Element Data</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="/admin/datarecord">
              <Icon :icon="['fa', 'file-edit']" />
              <span>Input Record</span>
            </Link>
          </li>
          <li class="nav-link">
            <Link href="/admin/inputdata">
              <Icon :icon="['fa', 'pen-square']" />
              <span>Input Data</span>
            </Link>
          </li>
          <!-- <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'file-signature']" />
              <span>Permohonan</span>
            </Link>
          </li> -->
          <!-- <li class="nav-link">
            <Link href="/admin/analisa">
              <Icon :icon="['fa', 'file-signature']" />
              <span>Analisa</span>
            </Link>
          </li> -->
          <li class="nav-link">
            <Link href="/admin/reporting">
              <Icon :icon="['fa', 'print']" />
              <span>Cetak Report</span>
            </Link>
          </li>
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/settingdata">
              <Icon :icon="['fa', 'gears']" />
              <span>Setting Data</span>
            </Link>
          </li>
          <li class="menu-title" v-if="[1].includes(role_id)">ADMINISTRASI</li>
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/users">
              <Icon :icon="['fa', 'users']" />
              <span>Akun Pengguna</span>
            </Link>
          </li>
          <li class="nav-link" v-if="[1].includes(role_id)">
            <Link href="/admin/roles">
              <Icon :icon="['fa', 'diagram-project']" />
              <span>Hak Akses</span>
            </Link>
          </li>
          <!-- <li class="nav-link">
            <Link href="#">
              <Icon :icon="['fa', 'gears']" />
              <span>Pengaturan Aplikasi</span>
            </Link>
          </li> -->
        </nav>
      </div>
      <div class="content p-2 flex-fill">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';

const renderActiveMenu = (pathname) => {
  document.querySelectorAll('.nav-link.active').forEach(el => {
    el.setAttribute('class', el.getAttribute('class').replace('active', '').trim());
  });
  // // cek dengan mencari link dengan posisi url saat ini
  // document.querySelectorAll('.nav-link > a[href="'+url.pathname+'"]').forEach(({ parentElement }) => {
  //   parentElement.setAttribute('class', parentElement.getAttribute('class').trim() + ' active');
  // });
  // cek semua link lalu bandingkan
  document.querySelectorAll('.nav-link > a:not([href=""])').forEach(el => {
    if(pathname.startsWith(el.getAttribute('href'))) {
      el.parentElement.setAttribute('class', el.parentElement.getAttribute('class').trim() + ' active');
    }
  });
}

export default {
  props: {
    auth: Object,
  },
  data() {
    return {
      signout: this.$inertia.form(),
      show_account: false,
      role_id: 0,
    }
  },
  methods: {
    logout() {
      this.signout.delete('/auth/logout');
    }
  },
  mounted() {
    renderActiveMenu(location.pathname);
    this.role_id = this.$page.props.auth.user.role.id;
  },
  created() {
    Inertia.on('start', (event) => {
      const { url } = event.detail.visit;
      renderActiveMenu(url.pathname);
    });
  }
}
</script>

<style lang="scss">
@import '../../css/bootstrap';
@import '../../css/style';
</style>
